import { createSelector } from 'reselect';

export const getCms = (state) => state.cms;

export const getStatuses = createSelector(
    getCms,
    (cms) => cms.status,
);

export const getModels = createSelector(
    getCms,
    (cms) => (postType) => cms[postType] || {},
);

export const getModel = createSelector(
    getModels,
    (getModelsSelector) => (postType, id) => {
        const models = getModelsSelector(postType);
        return models[id];
    },
);

export const getModelsList = createSelector(
    getModels,
    (getModelsSelector) => (postType) => {
        const models = getModelsSelector(postType);
        if (models) {
            return Object.values(models);
        }
        return [];
    },
);

export const getFilteredModelsList = createSelector(
    getModelsList,
    (getModelsListSelector) => (postType, filters) => {
        const models = getModelsListSelector(postType);
        return models.filter((model) => {
            let isMatch = true;
            Object.entries(filters).forEach(([key, value]) => {
                if (model[key] !== value) {
                    isMatch = false;
                }
            });
            return isMatch;
        });
    },
);

export const getLearnArticleResources = createSelector(
    [
        getModels,
        (state, postSlug) => postSlug,
        (state, postSlug, articleSlug) => articleSlug,
    ],
    (getModelsSelector, postSlug, articleSlug) => {
        const learnPosts = getModelsSelector('learn');

        const subPosts = (Array.isArray(learnPosts) ? learnPosts : [])
            // Takes for granted that only ever one post per slug choice (see post title field... hmm)
            .find((item) => item.title?.value === postSlug);

        // Array-defaulting accounts for not only unmatched articles, in the second case,
        // but also the fact that empty array fields are represented via empty string,
        // not empty array

        // due to ACF limitations, we had to use a different field type
        // to register resources on these posts
        if (
            ['rights', 'responsibilities'].includes(postSlug)
        ) {
            return (subPosts?.top_resources || [])
                /* eslint-disable camelcase */
                .map(({
                    top_icon,
                    top_title,
                    top_content,
                    top_file,
                }) => ({
                    icon: top_icon,
                    title: top_title,
                    content: top_content,
                    file: top_file,
                }));
            /* eslint-enable camelcase */
        }

        return (subPosts?.articles || [])
            .find((article) => article.title === articleSlug)
            ?.resources || [];
    },
);

export const getGlossaryTerm = createSelector(
    [
        getModels,
        (state, termId) => termId,
    ],
    (getModelsSelector, termId) => {
        const glossary = getModelsSelector('glossary');
        return glossary[termId];
    },
);
